// extracted by mini-css-extract-plugin
export default {"avatar":"IssuesFilter_avatar__M9AiG","active":"IssuesFilter_active__Oea1M"};